import { ModeType } from 'src/app/enums/mode-type.enum';
import { RegionType } from 'src/app/enums/region-type.enum';

export const environment = {
  configurationData: [],
  mode: ModeType.Aramark_Prod,
  production: true,
  US: {
    userPoolId: 'us-east-1_afct0WxYR',
    region: RegionType.USA,
    regionName: 'United States of America',
    clientId: '6gmkf4hh4g175o76iif7vkq5v4',
    appClients: [
      {
        id: 'Nmdta2Y0aGg0ZzE3NW83NmlpZjd2a3E1djQ=',
        urlOmni: 'https://identity.api.cbord.com',
        urlTLMiddleware: 'https://api.aramark.traylogistics.cbord.com',
      },
    ],
  },
  accessKeyId: '',
  secretAccessKey: '',
  parameterSSM: '',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
